import React, { Component } from "react";
import { connect } from "react-redux";
import { AddressProofComponent } from "../components";
import { saveAddressProof, saveAddressProofBackSide, saveAddressProofFrontSide, resetAddressProof } from "../actions";
import { updateRequestState, getRequestState } from "../../../shared/actions";
import { isEqual } from "lodash";
import { AD_RC, AD_AC, AD_VC, AD_DL, OTHER_PROOF } from "../../../assets/images";
import { getContent } from "../../../utils/helper";
import { PROOF_TYPE, PROOF_KEYS } from "../../../utils/constant";

class AddressProof extends Component {
   constructor(props) {
      super(props);

      this.addressProofList = [
         { label: getContent(props.languageJSON, PROOF_KEYS.LABEL_RATION_CARD), value: PROOF_TYPE.RATION, image: AD_RC },
         { label: getContent(props.languageJSON, PROOF_KEYS.LABEL_AADHAR), value: PROOF_TYPE.AADHAAR, image: AD_AC },
         { label: getContent(props.languageJSON, PROOF_KEYS.LABEL_VOTER_ID), value: PROOF_TYPE.VID, image: AD_VC },
         { label: getContent(props.languageJSON, PROOF_KEYS.LABEL_DL), value: PROOF_TYPE.DL, image: AD_DL },
         { label: getContent(props.languageJSON, PROOF_KEYS.LABEL_OTHER), value: PROOF_TYPE.OTHER, image: OTHER_PROOF },
      ];

      let selectedAddressProofOption = this.addressProofList.find((item) => item.value === props.addressProof);
      this.state = {
         step: 1,
         selectedAddressProofOption: selectedAddressProofOption ? selectedAddressProofOption : "",
         addressProofFrontSide: props.addressProofFrontSide,
         addressProofBackSide: props.addressProofBackSide,
         isCameraOn: false,
      };
   }

   componentDidMount = () => {
      this.props.getRequestState();
      if (this.props.history.location.params && this.props.history.location.params.to === "preview") {
         this.resetAddressProof();
      } else if (this.state.addressProofFrontSide) {
         this.setState({ step: 2 });
      }
   };

   componentDidUpdate = (prevProps) => {
      if (!isEqual(prevProps.addressProof, this.props.addressProof) && this.props.addressProof) {
         this.setState({
            selectedAddressProofOption: this.addressProofList.find((item) => item.value === this.props.addressProof),
         });
      }
      if (
         !isEqual(prevProps.addressProofFrontSide, this.props.addressProofFrontSide) &&
         this.props.addressProofFrontSide
      ) {
         this.setState({ addressProofFrontSide: this.props.addressProofFrontSide });
      }
      if (
         !isEqual(prevProps.addressProofBackSide, this.props.addressProofBackSide) &&
         this.props.addressProofBackSide
      ) {
         this.setState({ addressProofBackSide: this.props.addressProofBackSide });
      }
   };

   handleChange = (key, value) => {
      this.setState({ [key]: value });
   };

   goToScreen = (key, params) => {
      if (this.props.history.location && this.props.history.location.params) {
         this.props.history.push(this.props.history.location.params.to);
      } else {
         this.props.history.push({
            pathname: key,
            params: params,
         });
      }
   };
   resetAddressProof = () => {
      this.setState({ step: 1, addressProofFrontSide: "", addressProofBackSide: "", selectedAddressProofOption: "" });
      this.props.resetAddressProof();
   };

   goBack = () => {
      if (this.state.step === 2) {
         this.resetAddressProof();
      } else {
         this.props.history.replace("idProof");
      }
   };

   captureImage = (key, image) => {
      this.setState({ step: 2, [key]: image });
   };

   submitIdAsAddressProof = () => {
      const {
         requestState,
         idProof,
         idProofFrontSide,
         idProofBackSide,
         requestState: { template },
      } = this.props;
      this.setState({ addressProofFrontSide: idProofFrontSide, addressProofBackSide: idProofBackSide });
      this.props.saveAddressProofFrontSide(idProofFrontSide);
      if (idProofBackSide) this.props.saveAddressProofBackSide(idProofBackSide);
      this.props.updateRequestState({
         upload: [],
         state: "address_proof_captured",
         data: {
            address_proof_type: idProof,
            address_proof_backside: (requestState.data && requestState.data.id_backside) || idProofBackSide,
            address_proof_frontside: (requestState.data && requestState.data.id_frontside) || idProofFrontSide,
         },
         nextRoute: template.version === 1 ? "homeImage" : "video",
      });
   };

   submit = () => {
      const { addressProofFrontSide, addressProofBackSide, selectedAddressProofOption } = this.state;
      const {
         requestState,
         addressProof,
         requestState: { template },
      } = this.props;
      //if any of the field is updated we need to call the update state API but we need to upload to s3 only those that have actually changed
      if (
         !isEqual(selectedAddressProofOption.value, addressProof) ||
         !isEqual(addressProofFrontSide, this.props.addressProofFrontSide) ||
         !isEqual(addressProofBackSide, this.props.addressProofBackSide)
      ) {
         let upload = [];
         let data = {};
         if (
            !isEqual(addressProofFrontSide, this.props.addressProofFrontSide) &&
            !isEqual(addressProofBackSide, this.props.addressProofBackSide)
         ) {
            upload = addressProofBackSide
               ? ["address_proof_frontside", "address_proof_backside"]
               : ["address_proof_frontside"];
            data = {
               address_proof_type: selectedAddressProofOption.value,
               address_proof_backside: addressProofBackSide,
               address_proof_frontside: addressProofFrontSide,
            };
         } else if (!isEqual(addressProofFrontSide, this.props.addressProofFrontSide)) {
            upload = ["address_proof_frontside"];
            data = {
               address_proof_type: selectedAddressProofOption.value,
               address_proof_backside: (requestState.data && requestState.data.address_proof_backside) || "",
               address_proof_frontside: addressProofFrontSide,
            };
         } else if (!isEqual(addressProofBackSide, this.props.addressProofBackSide)) {
            upload = addressProofBackSide ? ["address_proof_backside"] : [];
            data = {
               address_proof_type: selectedAddressProofOption.value,
               address_proof_backside: addressProofBackSide,
               address_proof_frontside: (requestState.data && requestState.data.address_proof_frontside) || "",
            };
         }

         this.props.updateRequestState({
            upload: upload,
            state: "address_proof_captured",
            data: data,
            nextRoute: template.version === 1 ? "homeImage" : "video",
         });
      } else {
         this.goToScreen(template.version === 1 ? "homeImage" : "video");
      }
   };

   render() {
      const { language, languageJSON, idProof, saveAddressProof, idProofFrontSide, idProofBackSide } = this.props;
      const { step, addressProofFrontSide, addressProofBackSide, selectedAddressProofOption, isCameraOn } = this.state;
      return (
         <AddressProofComponent
            step={step}
            isCameraOn={isCameraOn}
            addressProofFrontSide={addressProofFrontSide}
            addressProofBackSide={addressProofBackSide}
            idProofFrontSide={idProofFrontSide}
            idProofBackSide={idProofBackSide}
            goBack={this.goBack}
            goToScreen={this.goToScreen}
            language={language}
            languageJSON={languageJSON}
            captureImage={this.captureImage}
            submit={this.submit}
            selectedAddressProofOption={selectedAddressProofOption}
            handleChange={this.handleChange}
            idProof={idProof}
            submitIdAsAddressProof={this.submitIdAsAddressProof}
            saveAddressProof={saveAddressProof}
            addressProofList={this.addressProofList}
         />
      );
   }
}

const mapStateToProps = ({
   idProof: { idProof, idProofFrontSide, idProofBackSide },
   addressProof: { addressProof, addressProofFrontSide, addressProofBackSide },
   language: { language, languageJSON },
   shared: { requestState },
}) => ({
   language,
   languageJSON,
   idProof,
   idProofFrontSide,
   idProofBackSide,
   addressProof,
   addressProofFrontSide,
   addressProofBackSide,
   requestState,
});

const mapDispatchToProps = {
   saveAddressProof,
   saveAddressProofFrontSide,
   saveAddressProofBackSide,
   resetAddressProof,
   updateRequestState,
   getRequestState,
};

export default connect(mapStateToProps, mapDispatchToProps)(AddressProof);
